import { createContext, useState, useEffect } from "react";
import { axiosUrl } from "./api/axios";

import HomeRoute from "./routes/HomeRoute";

export const UserContext = createContext({});

function App() {
  const [userData, setUserData] = useState({
    token: "",
    user: "",
  });

  useEffect(() => {
    const isLoggedIn = async () => {
      let token = localStorage.getItem("auth-token");
      if (token == null) {
        localStorage.setItem("auth-token", "");
        token = "";
      }

      const tokenResponse = await axiosUrl.post("/users/tokenIsValid", null, {
        headers: { "auth-token": token },
      });
      // console.log(tokenResponse.data);
      if (tokenResponse.data) {
        const userResponse = await axiosUrl.get("/users/profile", {
          headers: { "auth-token": token },
        });

        setUserData({
          token: token,
          user: userResponse.data,
        });

        return;
      }
    };
    isLoggedIn();
  }, [setUserData]);
  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      <HomeRoute />
      {/* <h1>HEllo</h1> */}
    </UserContext.Provider>
  );
}

export default App;
